import { Offering, OfferingStatus } from '@arrived/models';

export const isOfferingSoldOut = (offering: Offering): boolean => {
  return offering.fundedPercentNoDebt >= 100 || offering.status === OfferingStatus.FUNDED;
};
